import { MutationTree } from 'vuex';
import ActionTypes from '@/constants/action-types';
import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';
import { MerchantState } from '@/store/modules/merchant/state';

const mutations: MutationTree<MerchantState> = {

  [ActionTypes.GetMerchantDetails](state: MerchantState, merchant: MerchantDetailsModel) {
    state.merchant = merchant;
  },

  [ActionTypes.SetInfoPopupOpen](state: MerchantState, infoPopupOpen: boolean) {
    state.infoPopupOpen = infoPopupOpen;
  },

};

export default mutations;
